import { Environment } from "./types/environment.type";

export const environment: Environment = {
    apiUrl: "http://localhost:8080",
    sentry: {
        dsn: "https://79f87faef79e20cca8da491541f75c15@o341312.ingest.us.sentry.io/4509039083192321",
        enabled: false,
        environment: "development",
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", "http://localhost:8080"],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0
    },
    firebase: {
        projectId: "jobimag-dev",
        appId: "1:428581211479:web:ef46bc4680e44ea4fd4212",
        storageBucket: "jobimag-dev.firebasestorage.app",
        apiKey: "AIzaSyBvxQHaq0jP7ZBfxYRVIOrPWG_lLcROJSw",
        authDomain: "jobimag-dev.firebaseapp.com",
        messagingSenderId: "428581211479",
    },
    language: {
        defaultLang: "fr",
        availableLangs: ["en", "fr"]
    }
};
